import React from 'react'
import classNames from 'classnames'
import ModuleTitle from 'New/auto/series/components/module-title'
import hotHeaderLink from 'Components/new/links/hot-header-link'
import { MoreButton } from 'New/auto/series/components/more-button'
interface IHotHeaderProps {
  motor_name?: string | undefined | null
  series_id?: string | undefined | null
  group_id_str?: string | undefined
  user_id?: number | undefined
  article_sub_type?: number | undefined
  is_doudi?: boolean
  title?: string //标题名称
  src?: string //前面的小图标
  color?: string //字体颜色
  herf?: string //链接url
  as?: string //链接url
  moreButton?: boolean //更多按钮
  onClick?(): void //埋点方法
}
const HotHeader: React.FC<IHotHeaderProps> = ({
  motor_name,
  src,
  is_doudi,
  title,
  color,
  herf,
  as,
  moreButton = false,
  onClick,
}) => {
  return (
    <div className="tw-pt-12 tw-pb-10" onClick={onClick}>
      {hotHeaderLink({ herf, as })(
        <ModuleTitle
          titleColor={color}
          rightContent={
            moreButton ? (
              <MoreButton className="tw-hidden md:tw-inline">更多</MoreButton>
            ) : null
          }
        >
          <span
            className={classNames({
              'icon tw-pl-22': src,
              'hover:tw-text-common-orange': !!herf,
            })}
          >
            {`${
              !is_doudi ? motor_name?.replace(/(车友圈)$/g, '') || '' : ''
            }${title}`}
          </span>
        </ModuleTitle>
      )}
      <style jsx>
        {`
          .icon {
            background: url(${src}) no-repeat left center/18px 18px;
          }
        `}
      </style>
    </div>
  )
}
export default HotHeader
